export var KULT_SUBJECT_GROUPS_QUERY_KEY = "kult-subject-groups";
export var PERIODICAL_KULT_SUBJECT_GROUP_QUERY_KEY = "periodical-kult-subject-group";
